import React from 'react';
import TenantsTable from '../tables/TenantsTable/TenantsTable';
import styles from './TenantsBlock.module.scss';

const TenantsBlock = ({ tenants = [], companyName, queryKeys }) => {
  return (
    <div className={styles.root}>
      <TenantsTable
        tenants={tenants}
        companyName={companyName}
        queryKeys={queryKeys}
      />
    </div>
  );
};

export default TenantsBlock;
